import type {
  ObjectWorkspaceKind,
  ObjectWorkspaceTask,
  ObjectWorkspaceTasksState,
} from '@heidi/agents';
import { buildWorkHomeTaskRows } from '@heidi/agents/data';
import { ClinicalTaskStatus } from '@heidi/schema/ml-scribe';
import type { ClinicalTask } from '@heidi/tasks/contracts';

interface ResolveObjectWorkspaceTasksStateOptions {
  kind: ObjectWorkspaceKind;
  /** No subject to scope by (a patient with no linked profile): nothing to list. */
  hasScope: boolean;
  tasks: readonly ClinicalTask[] | undefined;
  isLoading: boolean;
  isError: boolean;
  now: Date;
}

export function resolveObjectWorkspaceTasksState({
  kind,
  hasScope,
  tasks,
  isLoading,
  isError,
  now,
}: ResolveObjectWorkspaceTasksStateOptions): ObjectWorkspaceTasksState {
  if (!hasScope) return { status: 'ready', tasks: [] };
  if (isLoading) return { status: 'loading' };
  if (isError) return { status: 'error' };

  const open = (tasks ?? []).filter(
    (task) =>
      task.status !== ClinicalTaskStatus.done &&
      task.status !== ClinicalTaskStatus.archived
  );
  return {
    status: 'ready',
    tasks: buildWorkHomeTaskRows(open, now).map(
      (row): ObjectWorkspaceTask => ({
        id: row.id,
        title: row.title,
        // A visit lists only its own tasks; a patient's span visits, so name the source.
        ...(kind === 'patient' && row.sessionLabel ? { detail: row.sessionLabel } : {}),
        dueDate: row.dueDate,
        inProgress: row.inProgress,
        launch: row.launch,
      })
    ),
  };
}
